import { render, staticRenderFns } from "./StayInformed.vue?vue&type=template&id=483d9637&"
import script from "./StayInformed.vue?vue&type=script&lang=js&"
export * from "./StayInformed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports